import { render, staticRenderFns } from "./AddAuth.vue?vue&type=template&id=00f07128&scoped=true"
import script from "./AddAuth.vue?vue&type=script&lang=js"
export * from "./AddAuth.vue?vue&type=script&lang=js"
import style0 from "./AddAuth.vue?vue&type=style&index=0&id=00f07128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f07128",
  null
  
)

export default component.exports